import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { adminLogin, getAdminKey } from '../../lib/api';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Lock, Loader2 } from 'lucide-react';
import { useToast } from '../../hooks/use-toast';

const AdminLogin = () => {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { toast } = useToast();

  if (getAdminKey()) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await adminLogin(password);
      toast({ title: 'Welcome back', description: 'Logged in successfully' });
      navigate('/admin', { replace: true });
    } catch {
      toast({ title: 'Invalid password', description: 'Try again', variant: 'destructive' });
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0a0a0a] px-4">
      <form onSubmit={submit} className="w-full max-w-sm bg-white rounded-xl p-8 shadow-2xl">
        <div className="flex justify-center mb-4">
          <div className="w-14 h-14 bg-[#bfff00] rounded-xl flex items-center justify-center">
            <Lock className="w-7 h-7 text-black" />
          </div>
        </div>
        <h1 className="text-2xl font-black text-center">Admin Login</h1>
        <p className="text-sm text-center text-neutral-500 mt-1">Fitness Pro Nutrition Dashboard</p>
        <div className="mt-6 space-y-3">
          <div>
            <Label htmlFor="pw">Password</Label>
            <Input id="pw" type="password" required autoFocus value={password} onChange={e => setPassword(e.target.value)} className="mt-1.5" />
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-[#0a0a0a] hover:bg-neutral-800 text-white font-bold">
            {loading ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Logging in...</> : 'Log In'}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default AdminLogin;
